import type { BuilderBrochureSettings } from "api-types/modelTypes";

export const defaultBrochureSettings: BuilderBrochureSettings = {
  imageType: "3d-line",
  //TODO: remove this column once we have migrated to the new pricing visibility settings
  displayOptionPrices: true,
  displayOptionDescriptions: false,
  displayAllOptions: false,
  displayFairHousingLogo: false,
  displayElevationPage: false,
  displayDefaultExteriorPaletteWhenSelected: false,
  displaySqft: true,
  displayPlanLabelDims: true,
  displayElectricalOptions: false,
  groupOptionsBySalesCategory: false,
  singlePlanPerPage: false,
  addElectricalPlans: false,
  legalDisclaimer: "",
  website: "",
  logoUrl: "",
};

export const PLACEHOLDER_LEGAL_DISCLAIMER = "Floorplans are approximate. Specifications may change without notice.";

export const DEFAULT_PUBLIC_BROCHURE_TERMS =
  "This brochure is for informational purposes only. Specifications, pricing, and availability may change without notice.";

/**
 * Merges brochure settings with defaults to ensure complete settings are saved.
 * - null → null (for locations: inherit from builder)
 * - undefined → undefined (field not being updated)
 * - object → merged with defaults (complete settings)
 */
export function mergeBrochureSettingsWithDefaults(
  settings: Partial<BuilderBrochureSettings> | null | undefined,
): BuilderBrochureSettings | null | undefined {
  if (settings === null) {
    return null;
  }
  if (settings === undefined) {
    return undefined;
  }
  return { ...defaultBrochureSettings, ...settings };
}
